export default {
  SET_TOKENS: 'SET_TOKENS',
  DELETE_TOKENS: 'DELETE_TOKENS'
};
